import React, { useState } from 'react';
import { Box, Typography, Divider, Button, Stack, Switch, TextField, Grid, FormControlLabel, Checkbox, InputAdornment } from '@mui/material';
import { useDispatch, useSelector } from "react-redux";
import AttachFiles from './attachfile';
import { useOutletContext } from "react-router-dom";

export default function Email() {
  const dispatch = useDispatch();
  const { setOpenSideBar, openSideBar } = useOutletContext();
  const { profileData } = useSelector((state) => state.profile);
  const { pdfEditortoken } = useSelector((state) => state.pdfEditortoken);
  const [email, setEmail] = useState("");
  const [ccemail, setCcEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [personalMsg, setPersonalMsg] = useState("");
  const [errors, setErrors] = useState({ email: "", ccemail: "", subject: "", personalMsg: "" });
  const [helperText, setHelperText] = useState({ email: "", ccemail: "", subject: "", personalMsg: "" });

  return (
    openSideBar && (
        <Stack sx={{ height: '100%', width: '80%' }}>
            <Box sx={{ height: '80px', display: "flex", alignItems:'center',justifyContent: "space-between" }}>
                <Typography noWrap component="p" sx={{ fontSize: '20px', fontWeight: 600, lineHeight: '20px', color: "#1D1D1D", m: "2em", ml: 2, }}>
                    Customise Invite
                </Typography>
            </Box>
            <Divider sx={{ borderWidth : "1px" }} />
            <Box
            sx={{
                borderRadius: '12px',
                background: '#fff',
                width: "100%",
                height: "100%",
                display: "flex",
                flexDirection: "column"
            }}
            >
                <Box sx={{ padding: "16px", display: "flex", flexDirection: "column", justifyContent: "space-between", overflow: "auto", height: "87.5%" }}>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 2, justifyContent: "space-between" }}>
                        <TextField
                            placeholder="Enter email"
                            type="email"
                            variant="outlined"
                            fullWidth
                            value={email}
                            onChange={(e) => {
                            setEmail(e.target.value)
                            setErrors((prevErrors) => ({ ...prevErrors, email: "" }));
                            setHelperText((prevHelperText) => ({ ...prevHelperText, email: "" }))
                        }}
                            error={!!errors.email}
                            sx={{
                            boxSizing: "border-box",
                            borderRadius: "10px",
                            backgroundColor: "#fff",
                            borderColor: "#C0C0C0",
                            borderWidth: "5px",
                            "& .MuiOutlinedInput-root": {
                                borderColor: errors.email ? "#FF6666" : "#C0C0C0",
                                backgroundColor: errors.email ? "#FFF1F1" : "none",
                                "&:hover fieldset": {
                                borderColor: errors.email ? "#FF6666" : "#C0C0C0",
                                },
                                "&.Mui-focused fieldset": {
                                borderColor: errors.email ? "#FF6666" : "#C0C0C0",
                                },
                            },
                            "& .MuiFormHelperText-root": {
                                color: "#FF6666",
                            },
                            }}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start" sx={{ maxHeight: "46px", paddingRight: "12px" }}>
                                        <Typography
                                            sx={{
                                                color: "#595959",
                                                fontSize: "13px",
                                                fontWeight: 400,
                                                transition: "color 0.2s ease-in-out",
                                                textDecoration: "none",
                                            }}
                                            >
                                            To:
                                        </Typography>
                                    </InputAdornment>
                                ),
                                sx: { 
                                    borderRadius: "10px",
                                    height: 46,
                                    fontSize: "13px",
                                    fontWeight: "400",
                                    "& input::-ms-reveal, & input::-ms-clear": {
                                        display: "none",
                                    },
                                },
                            }}
                        />
                        {!! errors.email && (
                            <Typography
                            sx={{
                                color: "#FF6666",
                                fontSize: "10px",
                                mt: 0.5,
                                mb: 0,
                                marginRight: "auto"
                            }}
                            >
                            {helperText.email}
                            </Typography>
                        )}
                    </Box>
                    
                    <Box sx={{ display: "flex", alignItems: "center", gap: 2, justifyContent: "space-between" }}>
                        <TextField
                            placeholder=""
                            type="email"
                            variant="outlined"
                            fullWidth
                            value={ccemail}
                            onChange={(e) => {
                            setCcEmail(e.target.value)
                            setErrors((prevErrors) => ({ ...prevErrors, ccemail: "" }));
                            setHelperText((prevHelperText) => ({ ...prevHelperText, ccemail: "" }))
                        }}
                            error={!!errors.ccemail}
                            sx={{
                            mt: 2,
                            boxSizing: "border-box",
                            borderRadius: "10px",
                            backgroundColor: "#fff",
                            borderColor: "#C0C0C0",
                            borderWidth: "5px",
                            "& .MuiOutlinedInput-root": {
                                borderColor: errors.ccemail ? "#FF6666" : "#C0C0C0",
                                backgroundColor: errors.ccemail ? "#FFF1F1" : "none",
                                "&:hover fieldset": {
                                borderColor: errors.ccemail ? "#FF6666" : "#C0C0C0",
                                },
                                "&.Mui-focused fieldset": {
                                borderColor: errors.ccemail ? "#FF6666" : "#C0C0C0",
                                },
                            },
                            "& .MuiFormHelperText-root": {
                                color: "#FF6666",
                            },
                            }}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start" sx={{ maxHeight: "46px", paddingRight: "12px" }}>
                                        <Typography
                                            sx={{
                                                color: "#595959",
                                                fontSize: "13px",
                                                fontWeight: 400,
                                                transition: "color 0.2s ease-in-out",
                                                textDecoration: "none",
                                            }}
                                            >
                                            CC:
                                        </Typography>
                                    </InputAdornment>
                                ),
                                sx: { 
                                    borderRadius: "10px",
                                    height: 46,
                                    fontSize: "13px",
                                    fontWeight: "400",
                                    "& input::-ms-reveal, & input::-ms-clear": {
                                        display: "none",
                                    },
                                },
                            }}
                        />
                        {!! errors.ccemail && (
                            <Typography
                            sx={{
                                color: "#FF6666",
                                fontSize: "10px",
                                mt: 0.5,
                                mb: 0,
                                marginRight: "auto"
                            }}
                            >
                            {helperText.ccemail}
                            </Typography>
                        )}
                    </Box>
                    
                    <Box sx={{ display: "flex", alignItems: "center", gap: 2, justifyContent: "space-between" }}>
                        <TextField
                            placeholder="{Sender name} has requested you to sign {document name}"
                            type="text"
                            variant="outlined"
                            fullWidth
                            multiline
                            minRows={2}
                            maxRows={6}
                            value={subject}
                            onChange={(e) => {
                            setSubject(e.target.value)
                            setErrors((prevErrors) => ({ ...prevErrors, subject: "" }));
                            setHelperText((prevHelperText) => ({ ...prevHelperText, subject: "" }))
                        }}
                            error={!!errors.subject}
                            sx={{
                            mt: 2,
                            boxSizing: "border-box",
                            borderRadius: "10px",
                            backgroundColor: "#fff",
                            "& .MuiOutlinedInput-root": {
                                borderColor: errors.subject ? "#FF6666" : "#C0C0C0",
                                backgroundColor: errors.subject ? "#FFF1F1" : "none",
                                "&:hover fieldset": {
                                borderColor: errors.subject ? "#FF6666" : "#C0C0C0",
                                },
                                "&.Mui-focused fieldset": {
                                borderColor: errors.subject ? "#FF6666" : "#C0C0C0",
                                },
                            },
                            "& .MuiFormHelperText-root": {
                                color: "#FF6666",
                            },
                            }}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start" sx={{ maxHeight: "46px", paddingRight: "12px", alignSelf: "start" }}>
                                        <Typography
                                            sx={{
                                                color: "#595959",
                                                fontSize: "13px",
                                                fontWeight: 400,
                                                transition: "color 0.2s ease-in-out",
                                                textDecoration: "none",
                                            }}
                                            >
                                            Subject:
                                        </Typography>
                                    </InputAdornment>
                                ),
                                sx: { 
                                    borderRadius: "10px",
                                    fontSize: "13px",
                                    fontWeight: "400",
                                    "& textarea": {
                                        resize: "none",
                                    },
                                    "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
                                        display: "none",
                                    },
                                    "& input[type=number]": {
                                        MozAppearance: "textfield",
                                    },
                                },
                            }}
                        />
                        {!! errors.subject && (
                            <Typography
                            sx={{
                                color: "#FF6666",
                                fontSize: "10px",
                                mt: 0.5,
                                mb: 0,
                                marginRight: "auto"
                            }}
                            >
                            {helperText.subject}
                            </Typography>
                        )}
                    </Box>

                    <Box sx={{ display: "flex", alignItems: "center", gap: 2, justifyContent: "space-between" }}>
                        <TextField
                            placeholder="Add a personal message here..."
                            type="text"
                            variant="outlined"
                            fullWidth
                            multiline
                            minRows={4}
                            maxRows={6}
                            value={personalMsg}
                            onChange={(e) => {
                            setPersonalMsg(e.target.value)
                            setErrors((prevErrors) => ({ ...prevErrors, personalMsg: "" }));
                            setHelperText((prevHelperText) => ({ ...prevHelperText, personalMsg: "" }))
                        }}
                            error={!!errors.personalMsg}
                            sx={{
                            mt: 2,
                            boxSizing: "border-box",
                            borderRadius: "10px",
                            backgroundColor: "#fff",
                            "& .MuiOutlinedInput-root": {
                                borderColor: errors.personalMsg ? "#FF6666" : "#C0C0C0",
                                backgroundColor: errors.personalMsg ? "#FFF1F1" : "none",
                                "&:hover fieldset": {
                                borderColor: errors.personalMsg ? "#FF6666" : "#C0C0C0",
                                },
                                "&.Mui-focused fieldset": {
                                borderColor: errors.personalMsg ? "#FF6666" : "#C0C0C0",
                                },
                            },
                            "& .MuiFormHelperText-root": {
                                color: "#FF6666",
                            },
                            }}
                            InputProps={{
                                sx: { 
                                    borderRadius: "10px",
                                    fontSize: "13px",
                                    fontWeight: "400",
                                    "& textarea": {
                                        resize: "none",
                                    },
                                    "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
                                        display: "none",
                                    },
                                    "& input[type=number]": {
                                        MozAppearance: "textfield",
                                    },
                                },
                            }}
                        />
                    </Box>
                    
                    <Typography sx={{ fontSize: "12px", fontWeight: 400, textAlign: "right", pt:1 }}>(Max 100 words allowed)</Typography>
                    {!! errors.personalMsg && (
                        <Typography
                        sx={{
                            color: "#FF6666",
                            fontSize: "10px",
                            mt: 0.5,
                            mb: 0,
                            marginRight: "auto"
                        }}
                        >
                        {helperText.personalMsg}
                        </Typography>
                    )}
                    <AttachFiles />
                </Box>
                <Box sx={{ padding: "16px", display: "flex", width: "100%", justifyContent: "space-between", mt: "auto" }}>
                    <Button variant="contained" sx={{ width: '126px', height: 46, color: "#185CB7", background: "transparent", textTransform: "none", fontSize: "16px", borderRadius: "10px", border: "1px solid #185CB7", boxShadow: "none", fontWeight: "600",}} >
                        Save Draft
                    </Button>

                    <Button variant="contained" sx={{ width: '172px', height: 46, color: "#185CB7", background: "#185CB7", textTransform: "none", fontSize: "16px", borderRadius: "10px", border: "1px solid #185CB7", boxShadow: "none", fontWeight: "600", 
                    "&:hover": { background: "#185CB7" }, 
                    "&.Mui-disabled": {
                    background: "#D8D8D8",
                    border: "1px solid #D8D8D8",
                    color: "#fff",
                    } }} disabled >
                        Review & Send
                    </Button>
                </Box>
            </Box>
        </Stack>
    )
  );
}
